import { Component, Input } from "@angular/core";

@Component({
    selector: 'corp-loading',
    standalone: true,
    templateUrl: 'corp-loading.component.html',
    imports: [],
})
export class CorpLoadingComponent  {
    @Input('corp-label') label: string = '';
}